import PageShell from "@/components/PageShell";
import Seo from "@/components/Seo";

export default function Info() {
  return (
    <>
      <Seo
        title="Juwai Morning Teer - Overview, Rules, Timing & Result Format"
        description="Learn about Juwai Morning Teer — the traditional archery-based number activity, result timings (F/R and S/R), how results are displayed, and how the archive works."
        path="/juwai-morning-teer"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "About Teer", path: "/juwai-morning-teer" },
        ]}
      />
      <PageShell>
        <article className="prose prose-sm sm:prose-base max-w-none" data-testid="info-article">
          <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight text-emerald-950">
            Juwai Morning Teer — Overview
          </h1>
          <p>
            Juwai Morning Teer is a traditional archery-based number activity
            practiced in the North East of India. Each day, archers shoot arrows
            at a target, and the number of arrows that hit the target within a
            fixed window becomes the round's number. Only the last two digits of
            the count form the two-digit result recorded for that round.
          </p>
          <h2 className="font-display font-bold text-2xl text-emerald-950 mt-8">
            Result Timings
          </h2>
          <ul>
            <li>
              <strong>First Round (F/R):</strong> approximately 10:30 AM
            </li>
            <li>
              <strong>Second Round (S/R):</strong> approximately 11:30 AM
            </li>
          </ul>
          <h2 className="font-display font-bold text-2xl text-emerald-950 mt-8">
            How Results Are Displayed
          </h2>
          <p>
            Once the day's rounds conclude, the site administrator manually
            enters the F/R and S/R numbers into the admin panel and publishes
            them. The homepage then updates instantly to show that day's
            Latest Result. If the admin has not yet published the result for
            the current date, the homepage will show{" "}
            <em>Waiting for Result</em>.
          </p>
          <h2 className="font-display font-bold text-2xl text-emerald-950 mt-8">
            Previous Results Archive
          </h2>
          <p>
            Every published result is automatically added to the Previous
            Results page. Records are listed newest first with the date, F/R
            and S/R for quick reference. Older records can be browsed by
            paginating through the archive.
          </p>
          <h2 className="font-display font-bold text-2xl text-emerald-950 mt-8">
            Common Numbers Page
          </h2>
          <p>
            The common numbers page shows reference figures for the day (Direct,
            House and Ending). These figures are only educational reference and
            carry no guarantee of accuracy.
          </p>
          <h2 className="font-display font-bold text-2xl text-emerald-950 mt-8">
            Important Note
          </h2>
          <p>
            Juwai Morning Teer, as presented on this website, is an
            informational resource only. This site does not operate the game,
            sell tickets, accept payments, or facilitate any form of betting or
            gambling. All content is offered for reference and general
            information only.
          </p>
        </article>
      </PageShell>
    </>
  );
}
